import { baseRestService } from "@/utils/baseRestService"
import { Config } from '@/config';

class AreaRaccoltaService extends baseRestService {

  constructor() {
    super()
    this.baseUrl = Config.api.apiServerUrl;
  }

  async List(inSituVersionId: string, ts: number): Promise<server.areaRaccolta[]> {
    return await this.Get<server.areaRaccolta[]>(`/api/in-situ/${inSituVersionId}/area-raccolta`, { ts: ts }) || [];
  }

  async Detail(id: string, inSituVersionId: string): Promise<server.areaRaccolta> {
    return await this.Get<server.areaRaccolta>(`/api/in-situ/${inSituVersionId}/area-raccolta/${id}`);
  }

  async Set(obj: server.areaRaccolta, inSituVersionId: string): Promise<server.areaRaccolta> {
    return await this.Post<server.areaRaccolta>(`/api/in-situ/${inSituVersionId}/area-raccolta`, obj);
  }

  async Remove(id: string, inSituVersionId: string): Promise<void> {
    return await this.Delete(`/api/in-situ/${inSituVersionId}/area-raccolta/${id}`);
  }
}

export const areaRaccoltaService = new AreaRaccoltaService();